import {
  FC, useMemo, useCallback, useRef, useState, useEffect,
} from 'react';
import { useTranslation } from 'react-i18next';
import { CommonLabel, FlexBox, useBreakpoint } from '@brg/ui';
import { AuthorsOffsetContainer, ProjectEditPageGridAuthorRow } from './styles';
import ProjectAuthorsDisplay from "./ProjectAuthorsDisplay";
import { AuthorT } from './types';
import { AuthorsMobileSearch } from 'shared/components/DropdownSearchBar/AuthorsMobileSearch';
import { LayoutConst } from 'core';
import { useProject } from 'shared/hooks/api/useProject';
import { AuthorsLabelContainer } from './styles';
import { useRouteMatch } from 'react-router-dom';

export type ProjectAuthorsChangeCbT = {
  authors: AuthorT[];
  action: string;
  removedValue?: AuthorT;
};

type PropsT = {
  label?: string;
  value: AuthorT[];
  onChange: (data: ProjectAuthorsChangeCbT) => void;
  onSelect?: (id: string) => boolean;
  required?: boolean;
  column?: boolean;
  persist?: boolean;
  isProjectEdit?: boolean;
  placeholder?: string;
  isTeamEdit?: boolean;
  isCompetitions?: boolean;
  isAdminPage?: boolean;
  showList?: boolean;
  errorMsg?: string;
  canRemoveUser?: boolean;
  isLMS?: string;
  isTeacherLMS?: boolean;
  isTeamMembers?: boolean;
  isPresentationLMS?: boolean;
  isPresentation?: boolean;
  ignoreContext?: boolean;
  teamId?: string;
  infoText?: string;
  teamModerationType?: number;
  customStyles?: any;
  minHeight?: number;
  orientation?: 'row' | 'column' | 'wide'
};

const ProjectAuthorsEdit: FC<PropsT> = ({
  label,
  value,
  onChange,
  onSelect,
  placeholder,
  orientation,
  required = false,
  persist= false,
  isProjectEdit,
  isAdminPage,
  isTeamEdit,
  isCompetitions,
  canRemoveUser,
  infoText,
  errorMsg,
  customStyles,
  showList,
  isLMS,
  isTeacherLMS,
  isTeamMembers,
  isPresentationLMS,
  isPresentation,
  teamId,
  teamModerationType,
  ignoreContext
}) => {
  const { i18n } = useTranslation();
  const inputRef = useRef<any>(null);
  const isS = useBreakpoint(LayoutConst.screen.s);
  const isTab = useBreakpoint(990);
  const [projectSource] = useProject(isLMS || "", i18n.language, isLMS);
    // @ts-ignore
  const currentTeamId = projectSource && projectSource?.teams?.[0].teamId;
  const iProjectEditPage = useRouteMatch("/edit");
  const isBookEditPage = useRouteMatch("/books/edit");
  const isProjectEditPage = iProjectEditPage || isBookEditPage;
  
  const [editing, setEditing] = useState(persist);

  const calcOrientation = useMemo(() => isPresentation ? 'column' : (orientation || 'row') , [isPresentation])

  const handleChange = useCallback(
    (authors: AuthorT[], { action, removedValue }: { action: string, removedValue?: AuthorT }) => {
      onChange({ authors, action, removedValue });
    },
    [onChange],
  );

  const handleAddClick = () => {
    setEditing(true);
  }

  useEffect(() => {
    if (editing) {
      inputRef?.current?.focus()
    }
  },[editing])

  const canRemove = useMemo(() => canRemoveUser , [canRemoveUser])

  const fakeLabel = useMemo(() => {
    if (isTab) return false;
    return ['row', 'wide']?.includes(calcOrientation)
  } , [isTab, calcOrientation])

  return (
    <ProjectEditPageGridAuthorRow isPresentation={isPresentation} direction={isPresentation ? 'column' : 'row'} isTeamEdit={isTeamEdit} isCompetitions={isCompetitions} isPresentationLMS={isPresentationLMS} directionMobile={isTeamEdit ? 'row' : 'column'} >
        <FlexBox direction={'column'} directionMobile='column' width={isTeamEdit ? 600 : '100%'} widthMobile={isTeamEdit ? ( isS ? '100%' : (isAdminPage ? 516 : 558)) :'100%'}>
          {!showList && (
            <AuthorsMobileSearch 
              editing={true}
              value={value} 
              label={label}
              infoText={infoText}
              required={required}
              orientation={calcOrientation}
              onAddClick={handleChange}
              onResetClick={() => setEditing(false)}
              onSelect={onSelect}
              isProjectEdit={isProjectEdit}
              isTeamEdit={isTeamEdit}
              placeholder={placeholder}
              isLMS={!!isLMS}
              ignoreContext={ignoreContext}
              isTeacherLMS={isTeacherLMS}
              isPresentationLMS={isPresentationLMS}
              isPresentation={isPresentation}
              teamId={currentTeamId || teamId}
              errorMsg={errorMsg}
              teamModerationType={teamModerationType}
              customStyles={customStyles}
            />
          )}
          {!!value?.length && (
            <FlexBox direction='row' >
              {fakeLabel && (
                <AuthorsLabelContainer isProjectEditPage={!!isProjectEditPage}>
                  <CommonLabel label=' ' orientation={calcOrientation} />
                </AuthorsLabelContainer>
              )}
              <ProjectAuthorsDisplay
                authors={value}
                onAddClick={handleAddClick}
                //@ts-ignore
                onRemoveClick={handleChange}
                editing={editing}
                isProjectEdit={isProjectEdit}
                isAdminPage={isAdminPage}
                isTeamMembers={isTeamMembers}
                canRemoveUser={canRemove}
                isPresentation={isPresentation}
                flexible={isTeamEdit || isAdminPage || isPresentation}
              />

            </FlexBox>
            
          )}
        </FlexBox>

    </ProjectEditPageGridAuthorRow>
  );
};

export default ProjectAuthorsEdit;
import {
  FC, useMemo, useCallback, useRef, useState, useEffect,
} from 'react';
import { useTranslation } from 'react-i18next';
import { CommonLabel, FlexBox, useBreakpoint } from '@brg/ui';
import { AuthorsOffsetContainer, ProjectEditPageGridAuthorRow } from './styles';
import ProjectAuthorsDisplay from "./ProjectAuthorsDisplay";
import { AuthorT } from './types';
import { AuthorsMobileSearch } from 'shared/components/DropdownSearchBar/AuthorsMobileSearch';
import { LayoutConst } from 'core';
import { useProject } from 'shared/hooks/api/useProject';
import { AuthorsLabelContainer } from './styles';
import { useRouteMatch } from 'react-router-dom';

export type ProjectAuthorsChangeCbT = {
  authors: AuthorT[];
  action: string;
  removedValue?: AuthorT;
};

type PropsT = {
  label?: string;
  value: AuthorT[];
  onChange: (data: ProjectAuthorsChangeCbT) => void;
  onSelect?: (id: string) => boolean;
  required?: boolean;
  column?: boolean;
  persist?: boolean;
  isProjectEdit?: boolean;
  placeholder?: string;
  isTeamEdit?: boolean;
  isCompetitions?: boolean;
  isAdminPage?: boolean;
  showList?: boolean;
  errorMsg?: string;
  canRemoveUser?: boolean;
  isLMS?: string;
  isTeacherLMS?: boolean;
  isTeamMembers?: boolean;
  isPresentationLMS?: boolean;
  isPresentation?: boolean;
  ignoreContext?: boolean;
  teamId?: string;
  infoText?: string;
  teamModerationType?: number;
  customStyles?: any;
  minHeight?: number;
  orientation?: 'row' | 'column' | 'wide'
};

const ProjectAuthorsEdit: FC<PropsT> = ({
  label,
  value,
  onChange,
  onSelect,
  placeholder,
  orientation,
  required = false,
  persist= false,
  isProjectEdit,
  isAdminPage,
  isTeamEdit,
  isCompetitions,
  canRemoveUser,
  infoText,
  errorMsg,
  customStyles,
  showList,
  isLMS,
  isTeacherLMS,
  isTeamMembers,
  isPresentationLMS,
  isPresentation,
  teamId,
  teamModerationType,
  ignoreContext
}) => {
  const { i18n } = useTranslation();
  const inputRef = useRef<any>(null);
  const isS = useBreakpoint(LayoutConst.screen.s);
  const isTab = useBreakpoint(990);
  const [projectSource] = useProject(isLMS || "", i18n.language, isLMS);
    // @ts-ignore
  const currentTeamId = projectSource && projectSource?.teams?.[0].teamId;
  const iProjectEditPage = useRouteMatch("/edit");
  const isBookEditPage = useRouteMatch("/books/edit");
  const isProjectEditPage = iProjectEditPage || isBookEditPage;
  
  const [editing, setEditing] = useState(persist);

  const calcOrientation = useMemo(() => isPresentation ? 'column' : (orientation || 'row') , [isPresentation])

  const handleChange = useCallback(
    (authors: AuthorT[], { action, removedValue }: { action: string, removedValue?: AuthorT }) => {
      onChange({ authors, action, removedValue });
    },
    [onChange],
  );

  const handleAddClick = () => {
    setEditing(true);
  }

  useEffect(() => {
    if (editing) {
      inputRef?.current?.focus()
    }
  },[editing])

  const canRemove = useMemo(() => canRemoveUser , [canRemoveUser])

  const fakeLabel = useMemo(() => {
    if (isTab) return false;
    return ['row', 'wide']?.includes(calcOrientation)
  } , [isTab, calcOrientation])

  return (
    <ProjectEditPageGridAuthorRow isPresentation={isPresentation} direction={isPresentation ? 'column' : 'row'} isTeamEdit={isTeamEdit} isCompetitions={isCompetitions} isPresentationLMS={isPresentationLMS} directionMobile={isTeamEdit ? 'row' : 'column'} >
        <FlexBox direction={'column'} directionMobile='column' width={isTeamEdit ? 600 : '100%'} widthMobile={isTeamEdit ? ( isS ? '100%' : (isAdminPage ? 516 : 558)) :'100%'}>
          {!showList && (
            <AuthorsMobileSearch 
              editing={true}
              value={value} 
              label={label}
              infoText={infoText}
              required={required}
              orientation={calcOrientation}
              onAddClick={handleChange}
              onResetClick={() => setEditing(false)}
              onSelect={onSelect}
              isProjectEdit={isProjectEdit}
              isTeamEdit={isTeamEdit}
              placeholder={placeholder}
              isLMS={!!isLMS}
              ignoreContext={ignoreContext}
              isTeacherLMS={isTeacherLMS}
              isPresentationLMS={isPresentationLMS}
              isPresentation={isPresentation}
              teamId={currentTeamId || teamId}
              errorMsg={errorMsg}
              teamModerationType={teamModerationType}
              customStyles={customStyles}
            />
          )}
          {!!value?.length && (
            <FlexBox direction='row' >
              {fakeLabel && (
                <AuthorsLabelContainer isProjectEditPage={!!isProjectEditPage}>
                  <CommonLabel label=' ' orientation={calcOrientation} />
                </AuthorsLabelContainer>
              )}
              <ProjectAuthorsDisplay
                authors={value}
                onAddClick={handleAddClick}
                //@ts-ignore
                onRemoveClick={handleChange}
                editing={editing}
                isProjectEdit={isProjectEdit}
                isAdminPage={isAdminPage}
                isTeamMembers={isTeamMembers}
                canRemoveUser={canRemove}
                isPresentation={isPresentation}
                flexible={isTeamEdit || isAdminPage || isPresentation}
              />

            </FlexBox>
            
          )}
        </FlexBox>

    </ProjectEditPageGridAuthorRow>
  );
};

export default ProjectAuthorsEdit;
